import React, { useState, useEffect } from 'react'

import DadosAssociado from '../../components/TabelaSimples/DadosAssociado'
import { useBuscaCadastros } from '../../modules/associado/hooks/useBuscaCadastros'
import MultiMatchFilter from '../../modules/shared/components/CampoMultiplosInputs/MatchFilter/MultiMatchFilter'
import MainTitle from '../../modules/shared/components/MainTitle'
import { retornaListaMatchPorListaCampo } from '../../Utilitarios'

const opcoesDeFiltro = ['Celular', 'CNPJ', 'E-mail', 'Razão Social', 'Telefone']

const campoPorOpcao = {
  'E-mail': 'email',
  'CNPJ': 'cnpj',
  'Razão Social': 'social_name',
  'Telefone': 'phone',
  'Celular': 'phone2',
}

const criaFiltroVazio = () => ({
  id: `${Date.now()}-${Math.random()}`,
  campo: "",
  valor: "",
})

export default function DadosDeAssociados() {
  const [filtrado, setFiltrado] = useState([])
  const [listaCadastrosCompleto, setListaCadastrosCompleto] = useState([])
  const [filtros, setFiltros] = useState([criaFiltroVazio()])

  const [resposta, buscaCadastros] = useBuscaCadastros()

  useEffect(() => {
    buscaCadastros()
  }, [buscaCadastros])

  useEffect(() => {
    if(Object.entries(resposta).length > 0) {
      const listaTabela = resposta.data.map(value => {
        const { cadastro, usuario } = value

        return {
          social_name: cadastro.getRazaoSocial(),
          cnpj: cadastro.getCnpj(),
          phone: cadastro.getTelefone(),
          phone2: cadastro.getTelefone2(),
          email: usuario.getEmail(),
          id: cadastro.getCadastroId()
        }
      })
      setFiltrado(listaTabela)
      setListaCadastrosCompleto(listaTabela)
    }
  }, [resposta])

  useEffect(() => {
    const filtrosPreenchidos = filtros.filter(filtro => filtro.campo !== "" && filtro.valor !== "")

    if(filtrosPreenchidos.length === 0) {
      setFiltrado(listaCadastrosCompleto)
      return
    }

    const novaLista = filtrosPreenchidos.reduce((listaAtual, filtro) => {
      return retornaListaMatchPorListaCampo(listaAtual, campoPorOpcao[filtro.campo], filtro.valor)
    }, listaCadastrosCompleto)

    setFiltrado(novaLista)
  }, [filtros, listaCadastrosCompleto])

  const handleAdicionarFiltro = () => {
    setFiltros(filtrosAtuais => [...filtrosAtuais, criaFiltroVazio()])
  }

  const handleAlterarFiltro = (id, novoValor) => {
    setFiltros(filtrosAtuais => filtrosAtuais.map(filtro => {
      if(filtro.id !== id) return filtro
      return { ...filtro, ...novoValor }
    }))
  }

  const handleRemoverFiltro = (id) => {
    setFiltros(filtrosAtuais => {
      const novaLista = filtrosAtuais.filter(filtro => filtro.id !== id)
      return novaLista.length > 0 ? novaLista : [criaFiltroVazio()]
    })
  }

  return (
    <>
      <MainTitle tituloPrincipal={true} titulo="Buscar cadastro por campo" />
      <MultiMatchFilter
        filtros={filtros}
        itensDoSelect={opcoesDeFiltro}
        onAdicionarFiltro={handleAdicionarFiltro}
        onAlterarFiltro={handleAlterarFiltro}
        onRemoverFiltro={handleRemoverFiltro}
      />
      <DadosAssociado
        cadastros={filtrado}
        onClick={() => {}} />
    </>
  )
}
